import { Typography } from "@mui/material";
import React, { ReactNode } from "react";
import { ErrorBoundary, FallbackProps } from "react-error-boundary";

const ErrorFallback = ({ error }: FallbackProps) => {
  return (
    <div role="alert">
      <Typography variant="h6">There were errors rendering form:</Typography>
      <Typography component="pre" color="error">
        {error.message}
      </Typography>
    </div>
  );
};

const PreviewErrorHandler = (props: {
  resetObject: unknown;
  children: ReactNode;
}) => {
  const { resetObject, children } = props;
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback} resetKeys={[resetObject]}>
      {children}
    </ErrorBoundary>
  );
};
export default PreviewErrorHandler;
